import { z } from 'zod'

export const supportFormSchema = z.object({
  accountId: z.number().nullable().optional(),
  message: z.string().trim().min(1, 'Message is required'),
  subject: z.string().min(1, 'Subject is required'),
  transactionId: z.number().nullable().optional(),
})
